import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

/**
 * Locale-aware navigation wrappers.
 *
 * Every component that previously imported from ``next/link`` /
 * ``next/navigation`` should import from ``@/i18n/navigation`` instead.
 * Source-code paths stay unprefixed (``/entities/123``); the wrapper
 * resolves the active locale and adds the prefix (``/zh-CN/entities/123``)
 * automatically.
 *
 * Drop-in API:
 *   - ``Link``           replaces ``next/link``
 *   - ``redirect``       replaces ``redirect`` from ``next/navigation``
 *   - ``useRouter``      replaces ``useRouter`` from ``next/navigation``
 *   - ``usePathname``    replaces ``usePathname`` from ``next/navigation``
 *   - ``getPathname``    server-side helper for building hrefs in RSCs
 */
export const { Link, redirect, useRouter, usePathname, getPathname } =
  createNavigation(routing);
